<template>
  <div class="authentication" :style="'height:'+winHeight+'px;'">
    <div class="step_one">
      <van-steps :active="step_active" active-color="#45B9BC">
        <van-step>身份验证</van-step>
        <van-step>个人信息</van-step>
        <van-step>证件上传</van-step>
      </van-steps>
    </div>

    <div class="tech_box">
      <ul>
        <li>
          <van-field v-model="name" label="姓名" placeholder="请输入姓名" />
        </li>

        <li>
          <van-field v-model="idcard" type="idcard" label="身份证号" placeholder="请输入身份证号" />
        </li>
        <li>
          <div class="van-cell van-cell--required van-cell--center van-field">
            <div class="van-cell__title van-field__label">
              <span>手机号</span>
            </div>
            <div class="van-cell__value">
              <div class="van-field__body">
                <input type="text" class="van-field__control" v-model="mobile" placeholder="请输入手机号" />
                <div class="van-field__button">
                  <button
                    class="van-button van-button--primary van-button--small"
                    v-show="!sandSuccess"
                    @click="get_code()"
                  >
                    <span class="van-button__text">
                      <p>发送验证码</p>
                    </span>
                  </button>
                  <p v-show="sandSuccess">{{sandTime}}s</p>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li>
          <van-field v-model="code" label="验证码" placeholder="请输入验证码" />
        </li>
      </ul>
    </div>

    <div class="btn_box">
      <button class="next_btn" @click="goapplyinfo()">下一步</button>
    </div>
  </div>
</template>

<script>
import storage from '@/common/storage'
export default {
  name: "authentication",
  components: {},
  data() {
    return {
      name: "",
      idcard: "",
      mobile: "",
      code: "",
      step_active: 0,
      winHeight: document.body.clientHeight,
      sandSuccess: false,
      sandTime: 60,
      sessionId: ""
    };
  },
  created() {},
  methods: {
    goapplyinfo() {
      if (this.mobile == "") {
        this.$toast({
          message: "请输入手机号"
        });
      }
      if (this.name == "") {
        this.$toast({
          message: "请输入姓名"
        });
      }
      if (this.idcard == "") {
        this.$toast({
          message: "请输入身份证"
        });
      }
      let str = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[35678]|18[0-9]|14[57])[0-9]{8}$/;
      if (str.test(this.mobile)) {
        this.axios({
          url: this.api.member.check_code,
          data: {
            code: this.code,
            name: this.name,
            idcard: this.idcard,
            mobile: this.mobile,
            sessionId: this.sessionId
          }
        }).then(res => {
          if (res.error == 0) {
            storage.s_setItem('authenticationInfo',res.data);
            this.$toast({
              message: res.msg,
              type: "success",
              onClose: () => {
                this.$router.push('/applyinfo');
              }
            });
          } else {
            this.$toast({
              message: res.error
            });
          }
        });
      }else{
        this.$toast({
          message: "手机号格式错误"
        });
      }
    },
    countTime() {
      var that = this;
      var currentTime = 60;
      var interval = setInterval(function() {
        currentTime--;
        that.sandTime = currentTime;
        if (currentTime < 0) {
          clearInterval(interval); //清除计时器
          that.sandSuccess = false;
          that.sandTime = 60;
        }
      }, 1000);
    },
    get_code() {
      if (this.mobile == "") return;
      let str = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
      if (str.test(this.mobile)) {
        this.axios({
          url: this.api.member.get_code,
          data: {
            mobile: this.mobile,
            temp:"tech_apply"

          }
        }).then(res => {
          if (res.error === 0) {
            this.countTime();
            this.sandSuccess = true;
            this.sessionId = res.sessionId;
            this.$toast("信息已发送");
          } else {
            this.$toast(res.error);
          }
        });
      } else {
        this.$toast("手机号不正确");
      }
    }
  }
};
</script>
<style scoped>
.van-cell {
  border-bottom: 1px solid #eee;
}
.authentication {
  background-color: white;
}
.bz {
  position: absolute;
}
.van-step--horizontal .van-step__circle-container {
  top: 45px !important;
}
.van-step--horizontal .van-step__line {
  top: 45px !important;
}
.btn_box {
  text-align: center;
}
.next_btn {
  color: white;
  background-color: #45b9bc;
  border-radius: 5px;
  padding: 0.4rem 5rem;
  margin-top: 2.5rem;
  font-size: 0.9rem;
}
.van-steps--horizontal {
  padding: 0.75rem 2rem;
}
.tech_box li {
  background-color: white;
  padding: 0.1rem 1.25rem;
}
.van-button--primary {
  background-color: white;
  border: 1px solid #45b9bc;
  border-radius: 5px;
  color: #45b9bc;
}
.van-step--horizontal .van-step__title {
  font-size: 0.7rem;
}
</style>



// WEBPACK FOOTER //
// src/views/technician/authentication.vue